import { BhMessageBannerComponent } from './../bh-message-banner/bh-message-banner.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    BhMessageBannerComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [
    BhMessageBannerComponent
  ]
})
export class BhMessageBannerComponentModule { }